import { CreateTRPCReact, createTRPCReact } from '@trpc/react-query';
import { httpBatchLink, httpLink, splitLink } from '@trpc/client';
import { AppRouter } from '@server'

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>()

const url = `${import.meta.env.VITE_SERVER_URI}/trpc`;

const linkOptions = {
    url,
    headers: () => {
        const token = localStorage.getItem('token');
        return {
            Authorization: token ? `Bearer ${token}` : '',
        };
    },
    fetch(url: URL | RequestInfo, options?: RequestInit) {
        return fetch(url, {
            ...options,
            credentials: 'include',
        });
    },
};

export const trpcClient = trpc.createClient({
    links: [
        splitLink({
            condition(op) {
                // check for context property `skipBatch`
                return Boolean(op.context.skipBatch);
            },
            // when condition is true, use normal request
            true: httpLink(linkOptions),
            // when condition is false, use batching
            false: httpBatchLink(linkOptions),
        }),
    ],
});